let IdNamePair = require('./IdNamePair');

module.exports = class Language extends IdNamePair {};
